'use client';

import styles from './SectionDivider.module.css';

interface SectionDividerProps {
  withCorners?: boolean;
}

export function SectionDivider({ withCorners = true }: SectionDividerProps) {
  return (
    <div className={`${styles.divider} ${withCorners ? styles.withCorners : ''}`}>
      <div className={styles.line} />
      {withCorners && (
        <>
          <span className={styles.cornerLeft} />
          <span className={styles.cornerRight} />
        </>
      )}
    </div>
  );
}
